import {Component, DOCUMENT, effect, inject, PLATFORM_ID, signal} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {TranslocoService} from "@jsverse/transloco";
import {ArtworksService, ArtistsService, LayoutService} from "@services";
import {ToastComponent} from "@components";
import {SpinnerComponent} from "./components/spinner/spinner.component";
import {filter} from "rxjs";
import {isPlatformBrowser} from "@angular/common";
import {MatDialog} from "@angular/material/dialog";
import {
  CookiePolicyModalComponent,
  CookieService
} from "./components/cookie-policy-modal/cookie-policy-modal.component";
import {WINDOW} from "./injector";
import {AuthenticationService} from "@services";
import {DrawerComponent} from "./components/layout/drawer/drawer.component";
import {FormsModule} from "@angular/forms";
import {CartComponent} from "./components/cart/cart.component";
import {GoogleApiServices} from "./services/google.api-services";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, SpinnerComponent, DrawerComponent, FormsModule, CartComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'wundart-fe';
  showSpinner = signal(false)
  maintenance = signal(false);
  private readonly platform = inject(PLATFORM_ID)
  private readonly window = inject(WINDOW)
  private readonly document = inject(DOCUMENT)
  private readonly cookieService = inject(CookieService);
  private readonly authenticationService = inject(AuthenticationService)
  private readonly router = inject(Router);
  private readonly layoutService = inject(LayoutService);
  private readonly googleApiService = inject(GoogleApiServices);
  showCart = this.layoutService.isShowingCart;
  dialog = inject(MatDialog);

  constructor(trasloco: TranslocoService,
              artworksService: ArtworksService,
              artistsService: ArtistsService,
              layoutService: LayoutService,) {

    
    trasloco.setActiveLang('en')
    artworksService.load()
    artistsService.loadArtists()

    this.googleApiService.initScript();

    layoutService.spinner$
      .subscribe(show => this.showSpinner.set(show));

    effect(() => {
      const user = this.authenticationService.current();
      const ready = this.cookieService.ready();
      if (user && ready) this.cookieService.setEmail(user.email);
    });


    if (isPlatformBrowser(this.platform)) {
      if (!this.cookieService.preferences()) {
        this.openDialog()
      } else
        this.cookieService.initScripts(this.authenticationService.current()?.email).then(d => {
          console.log('marketing-enabled')
        });
    }

    this.layoutService.askForCookiePolicy$.subscribe(d => {
      this.openDialog()
    })

    this.router.events.pipe(
      filter(d => d instanceof NavigationEnd),
      filter(d => !d.url.includes('backoffice'))
    ).subscribe(
      d => {
        this.cookieService.page()
      }
    )
  }


  openDialog() {
    this.dialog.open(CookiePolicyModalComponent, {
      hasBackdrop: true,
      closeOnNavigation: false,
      disableClose: true,
      width: '800px',
      maxHeight: Math.max(this.window.innerHeight, 600) + 'px',
      maxWidth: '800px',
      panelClass: 'cookie-policy-backdrop'
    });
  }
}
